import { OrderDetails } from '../types';

/**
 * Transforms the Shopify Customer Account API object into OrderDetails format
 * 
 * This utility function extracts order information from the API object structure
 * and converts it to match the GraphQL OrderDetails type format, ensuring
 * consistent data structure across different data sources.
 * 
 * @param api - The Shopify Customer Account API object
 * @returns OrderDetails object if order data is available, null otherwise
 */
export const buildOrderDetailsFromApi = (api: any): OrderDetails | null => {
  const order = api.order?.current;
  const lines = api.lines?.current || [];
  const cost = api.cost;
  const customer = api.authenticatedAccount?.customer?.current;

  if (!order) {
    return null;
  }

  // Build line items in the expected format
  const lineItems = {
    edges: lines.map((line: any) => ({
      node: {
        id: line.id || '',
        title: line.merchandise?.title || '',
        quantity: line.quantity || 0,
        product: {
          id: line.merchandise?.product?.id || '',
        },
        variant: {
          id: line.merchandise?.id || '',
          title: line.merchandise?.title || '',
        },
        customAttributes: line.attributes || [],
      },
    })),
  };

  // Build order details
  const orderDetails: OrderDetails = {
    id: order.id,
    name: order.name,
    createdAt: order.processedAt || new Date().toISOString(),
    totalPriceSet: cost?.totalAmount?.current ? {
      shopMoney: {
        amount: cost.totalAmount.current.amount.toString(),
        currencyCode: cost.totalAmount.current.currencyCode,
      },
    } : undefined,
    lineItems,
    customer: customer ? {
      displayName: customer.id || '', // We don't have name in customer object
    } : undefined,
    metafields: {
      edges: [],
    },
    tags: [],
  };

  return orderDetails;
};

